import { combineReducers } from 'redux';
import { authReducer } from './comp/login/authReducer';
import globalReducer from './comp/global/globalReducer';
import adminPeekReducer from './comp/adminPeek/adminPeekReducer';

export const rootReducer = combineReducers({
  auth: authReducer,
  global: globalReducer,
  adminPeek: adminPeekReducer,
});
